import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import type { HomeSelectionListRowProps } from 'features/shared/inventory/selections/home-selections/types/HomeSelectionListRowProps';
import './HomeSelectionListRowMobile.scss';

const na = (val: string) => (val.trim() !== '' ? val.trim() : 'N/A');

/**
 * Mobile options row — same fields as {@link HomeSelectionListRowDesktop}.
 */
const HomeSelectionListRowMobile: React.FC<HomeSelectionListRowProps> = ({
  title,
  notes
}) => {
  return (
    <IonItem lines="none" className="hk-mobile-home-selection-row">
      <IonLabel className="hk-mobile-home-selection-row-body">
        <IonText className="hk-mobile-home-selection-row-name">
          <p>{na(title)}</p>
        </IonText>
        {notes.trim() !== '' && (
          <IonText className="hk-mobile-home-selection-row-field">
            <p>{notes.trim()}</p>
          </IonText>
        )}
      </IonLabel>
    </IonItem>
  );
};

export default HomeSelectionListRowMobile;
